// extracted by mini-css-extract-plugin
export default {"container":"DayMetricComponent_container__ZF3su","icon":"DayMetricComponent_icon__mjNJW"};